document.addEventListener('DOMContentLoaded', function() {
  var banners = document.querySelectorAll('.bf-banner');

  banners.forEach(function(banner) {
    var deadlineStr = banner.getAttribute('data-deadline');
    if (!deadlineStr) return;

    var deadline = new Date(deadlineStr).getTime();
    var timerEl = banner.querySelector('.bf-banner__timer');
    if (!timerEl) return;

    function updateTimer() {
      var now = Date.now();
      var distance = deadline - now;

      if (distance <= 0) {
        timerEl.textContent = 'Ends soon';
        clearInterval(interval);
        return;
      }

      var days    = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var parts = [];
      if (days > 0) {
        parts.push(days + 'd');
      }
      parts.push(
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0')
      );

      timerEl.textContent = parts.join(' ');
    }

    updateTimer();
    var interval = setInterval(updateTimer, 1000);
  });
});
